import {hybridSelectorAll} from '../Library/Dom';

const state = {
    initializedElements: new WeakMap(),
};

const addClass = (className, ...elements) => {
    elements.forEach(element => element.classList.add(className));
};

const collapseElements = handle => {
    const elements = state.initializedElements.get(handle);

    handle.classList.remove('collapsed');

    addClass('collapsing', ...elements);

    elements.forEach(element => {
        const onEnd = () => {
            element.removeEventListener('transitionend', onEnd);
            element.classList.remove('collapsing');
            element.classList.remove('collapsed');
            element.style.height = ''
        };

        element.addEventListener('transitionend', onEnd);

        element.style.height = `${element.scrollHeight}px`;
    });
};

const showElements = handle => {
    const elements = state.initializedElements.get(handle);

    handle.classList.add('collapsed');

    addClass('collapsing', ...elements);

    elements.forEach(element => {
        element.style.height = `${element.scrollHeight}px`;

        // reading a property forces the browser to reflow (?) such that it reads the height we just set before setting it to 0 afterward
        // do not remove this even if it objectively looks like it does nothing
        element.offsetHeight;

        const onEnd = () => {
            element.removeEventListener('transitionend', onEnd);
            element.classList.remove('collapsing');
            element.classList.add('collapsed');
            element.style.height = ''
        };

        element.addEventListener('transitionend', onEnd);

        element.style.height = '0';
    });
};

export const collapse = async (handle, targetSelector) => {
    const cachedElements = state.initializedElements.get(handle);

    if (!cachedElements || cachedElements.some(element => !element.isConnected)) {
        handle.classList.add('toggle-handle');

        const elements = hybridSelectorAll(handle, targetSelector);

        addClass('collapsible', ...elements);

        state.initializedElements.set(handle, elements);
    }

    if (handle.classList.contains('collapsed')) {
        collapseElements(handle);
    } else {
        showElements(handle);
    }
};